import type { TerminalConfig } from '../config';
import { createSafeContext } from './createSafeContext';

/**
 * Holds the host-supplied `TerminalConfig` so any leaf component reaches it
 * without prop-drilling. Set once by `<Terminal config={…}>`.
 */
export const [useTerminalConfig, TerminalConfigProvider] =
  createSafeContext<TerminalConfig>('TerminalConfig');
